export default __webpack_public_path__ + "static/media/etabloc.8b1f087c.png";